import ProfileCompleteness from '@/interfaces/profile-completeness.interface'
import { BehaviorSubject } from 'rxjs'
export default new BehaviorSubject<ProfileCompleteness>(null)
